import { Row } from '@/components/container/Container';
import { TextLabelLarge2 } from '@/components/text/Texts';
import type { VehicleTypeDto } from '@/modules/vehicle/engine/ActivityTypes';

export function readVehicleTypeIsActive(v: VehicleTypeDto): boolean {
	const o = v as unknown as Record<string, unknown>;
	const raw = o.IsActive ?? o.isActive;
	return raw === true || raw === 'true';
}

export function firstActiveVehicleType(
	types: VehicleTypeDto[],
): VehicleTypeDto | undefined {
	return types.find((t) => readVehicleTypeIsActive(t));
}

export const SectionHeading = ({
	title,
	required,
}: { title: string; required?: boolean }) => (
	<Row className="gap-1 items-baseline">
		<TextLabelLarge2 className="text-primary font-semibold" text={title} />
		{required ? (
			<span className="font-poppins text-label-large2 font-semibold text-error60">
				*
			</span>
		) : null}
	</Row>
);
